/* eslint-disable no-console */
import Vue from "vue";
import VueRouter from "vue-router";
import Vuetify from "vuetify/lib";
import VueKonva from "vue-konva";
import VueGtag from "vue-gtag";
import { register } from "register-service-worker";
import App from "./App.vue";
import Home from "./views/Home.vue";
import Search from "./views/Search.vue";
import pridi from "./data/pridi.js";
import puey from "./data/puey.js";

const libraries = { pridi, puey };
const keys = Object.keys(libraries);
Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(Vuetify);
Vue.use(VueKonva);
Vue.use(VueGtag, {
  config: {
    id: "UA-148203670-1",
    params: {
      custom_map: {
        dimension1: "library",
        dimension2: "category",
        dimension3: "code",
        dimension4: "barcode"
      },
      send_page_view: false
    }
  }
});
if (process.env.NODE_ENV === "production") {
  register("/service-worker.js", {
    ready: () => console.log("ready"),
    registered: () => console.log("registered"),
    cached: () => console.log("cached"),
    updatefound: () => console.log("updatefound"),
    updated: () => console.log("updated"),
    offline: () => console.log("offline"),
    error: error => console.error(error)
  });
}

new Vue({
  router: new VueRouter({
    routes: keys
      .map(i => ({
        path: "/" + libraries[i].name + "/:category/:code/:barcode?",
        component: Search,
        props: libraries[i]
      }))
      .concat([
        { path: "/", component: Home, props: { keys, libraries } },
        { path: "*", redirect: "/" }
      ])
  }),
  vuetify: new Vuetify({
    icons: { iconfont: "mdi" },
    theme: { themes: { light: { primary: "#C3002F" } } }
  }),
  render: h => h(App)
}).$mount("#app");
